import { NODE_ENV, PROD_DOMAIN } from 'constants/env';

export const isProductionHost = () => {
    return window && PROD_DOMAIN?.includes(window.location.hostname);
};

export const isProductionEnv = NODE_ENV === 'production';
